import { Img } from '../../../base/components/native/img'

export const HistoryImage = (url: string) => {

    const base = Img(url, {width: 100})
    base.cssClass({
        borderRadius: '20px',
        margin: '10px'
    })

    return base
}